import React, {useEffect} from 'react'
import './home.css'
import video from '../../Assets/video.mp4'

import Aos from 'aos'
import 'aos/dist/aos.css'

import {GrLocation} from 'react-icons/gr'
import {FiFacebook} from 'react-icons/fi'
import {FiInstagram} from 'react-icons/fi'
import {AiFillYoutube} from 'react-icons/ai'
import {FaSearch} from 'react-icons/fa'
import {AiOutlineTwitter} from 'react-icons/ai'

const Home = () => {

  useEffect(()=>{
    Aos.init({duration: 2000})
  },[])

  return (
    <section className='home'>
      <div className="overlay"></div>
      <video src={video} muted autoPlay loop type="video/mp4"></video>
    
    <div className="homeContent container">
      <div className="textDiv">

        <span data-aos="fade-up" className="smallText">
          Selamat Pagi
        </span>

        <h1 data-aos="fade-up" className='homeTitle'>
          Mau kemana hari ini?
        </h1>

      </div>

      <div data-aos="fade-up" className="cardDiv grid">
        <div className="destinationInput">
          <label htmlFor="city">Location</label>
          <div className="input flex">
            <input type="text" placeholder='Masukkan nama kota...' />
            <GrLocation className="icon"/>
          </div>
        </div>

        <div className="dateInput">
          <label htmlFor="date">Select your date</label>
          <div className="input flex">
            <input type="date"/>
          </div>
        </div>

        <div className="priceInput">
          <div className="label_total flex">
            <label htmlFor="price">Max price:</label>
            <h3 className="total">Rp.1.000.000</h3>
          </div>
          <div className="input flex">
            <input type="range" max="5000" min="1000"/>
          </div>
        </div>

        <div className="seacrhOptions flex">
          <FaSearch className="icon"/>
          <span>Search</span>
        </div>
      </div>

      <div className="homeFooterIcons flex">
        <div className="rightIcons">
          <FiFacebook className="icon"/>
          <FiInstagram className="icon"/>
        </div>

        <div className="leftIcons">
          <AiOutlineTwitter className="icon"/>
          <AiFillYoutube className="icon"/>
        </div>
      </div>
    </div>

    </section>
  )
}

export default Home